<div class="offering-environments">
  <h1 class="ui-heading-1-bold offering-environments-title">{{ section() }}</h1>

  <div class="cards">
    @for (environment of environments(); track $index) {
      <inexp-teaser-card
        [title]="environment.name"
        [description]="environment.serviceLevelAgreement"
        [primaryBtn]="environment.url"
      ></inexp-teaser-card>
    }
  </div>
</div>
